// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__2jk--"};